export function sortResult(arr) {
    arr.sort((a, b) => {
        return parseInt(a.sort) - parseInt(b.sort)
    });
    return arr
}
export function getToken() {
    var token = getCookie('_token'),
        pattern = /{i:\d+;s:\d+:"_token";i:\d+;s:\d+:"(.+?)";}/,
        tokens = pattern.exec(decodeURIComponent(token))
    token = tokens ? tokens[1] : ''
    return token
}

export function getCookie(name) {
    var strcookie = document.cookie

    var arrcookie = strcookie.split('; ')

    for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split('=')
        if (arr[0] == name) {
            return arr[1]
        }
    }
    return ''
}

export const delCookie = (name, domain, path = "/") => {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let cval = getCookie(name)
  if (cval != null && !domain) document.cookie = `${name}=${cval}; expires=${exp.toGMTString()}; path=${path}`
  else if (cval != null && domain) document.cookie = `${name}=${cval}; expires=${exp.toGMTString()}; path=${path}; domain=${domain}`
}

export const setCookie = (name, value, domain, path = "/", span = 600000) => {
  let expires = new Date(Date.now() + span);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};domain=${domain};path=${path};`;
};

export function getQueryParamByKey(url, paramName) {
  // var url = document.location.toString()
      // 如果url中有特殊字符则需要进行一下解码
  url = decodeURI(url)
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
      var arrPara = arrObj[1].split("&");
      var arr;
      for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          if (arr != null && arr[0] == paramName) {
              return decodeURIComponent(arr[1]);
          }
      }
      return "";
  } else {
      return "";
  }
}

export const sleep = (time) => {
  return new Promise(function(resolve) {
      setTimeout(resolve, time);
  })
}



// WEBPACK FOOTER //
// ./src/util/util.js